/**
 * @generated SignedSource<<012ea3b073ed977c78939a66fa71649a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingBriefsShowMeetingBriefSuggestedActionQuery$variables = {
  id: string;
};
export type MeetingBriefsShowMeetingBriefSuggestedActionQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"MeetingBriefs_useShowMeetingBriefSuggestedAction">;
  } | null;
};
export type MeetingBriefsShowMeetingBriefSuggestedActionQuery = {
  response: MeetingBriefsShowMeetingBriefSuggestedActionQuery$data;
  variables: MeetingBriefsShowMeetingBriefSuggestedActionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingBriefsShowMeetingBriefSuggestedActionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MeetingBriefs_useShowMeetingBriefSuggestedAction"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MeetingBriefsShowMeetingBriefSuggestedActionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeBlockType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "attendeePersonCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalAttendeePersonCount",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventStart",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventEnd",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "groupName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "previousNoteWithEvent",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingRecording",
                    "kind": "LinkedField",
                    "name": "meetingRecordings",
                    "plural": true,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingBrief",
                "kind": "LinkedField",
                "name": "meetingBrief",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              }
            ],
            "type": "Note",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ecb962eb42ba5ff6922e95cd2bc3fcec",
    "id": null,
    "metadata": {},
    "name": "MeetingBriefsShowMeetingBriefSuggestedActionQuery",
    "operationKind": "query",
    "text": "query MeetingBriefsShowMeetingBriefSuggestedActionQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...MeetingBriefs_useShowMeetingBriefSuggestedAction\n    id\n  }\n}\n\nfragment MeetingBriefs_useShowMeetingBriefSuggestedAction on Note {\n  event {\n    timeBlockType\n    attendeePersonCount\n    externalAttendeePersonCount\n    id\n  }\n  eventStart\n  eventEnd\n  groupName\n  previousNoteWithEvent {\n    meetingRecordings {\n      id\n    }\n    id\n  }\n  meetingBrief {\n    id\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "576d724fe8adb696e0f0e6f626660bf0";

export default node;
